import { graphql, PageProps } from 'gatsby';

import { StandardLayout } from '~/components/layout';
import { RichText } from '~/components/rich-text';
import { Section } from '~/components/section';
import { isRichText } from '~/utilities/rich-text.utility';

const BioPage = ({ data }: PageProps<Queries.BioPageQuery>) => {
  const person = data.contentfulPerson;

  return (
    <StandardLayout>
      <Section title="About Roel Vanstiphout">
        {isRichText(person?.bio) && (
          <RichText content={person?.bio} variant="two-column" />
        )}
      </Section>
    </StandardLayout>
  );
};

export default BioPage;

export const pageQuery = graphql`
  query BioPage {
    contentfulPerson(isPortfolioOwner: { eq: true }) {
      bio {
        raw
        references {
          ... on ContentfulAsset {
            __typename
            contentful_id
            title
            description
            gatsbyImageData(placeholder: BLURRED)
          }
        }
      }
    }
  }
`;
